import {supabase} from '../../adapters/database/supabaseClient'
export type SwitchKind='cashier'|'operator'
type SumUpResult={ok:boolean;paid?:boolean;status?:string;launchUrl?:string;transactionCode?:string;error?:string;details?:string;environment?:string;simulated?:boolean}
export async function sumupSwitch(action:'launch'|'status',input:{eventId:string;paymentId:string;sessionToken:string;kind:SwitchKind}){
 const {data,error}=await supabase.functions.invoke('sumup-payment-switch',{body:{action,...input}})
 if(error){
  let message=error.message||'Errore SumUp'
  const response=(error as unknown as {context?:Response}).context
  if(response){try{const body=await response.clone().json() as SumUpResult;message=body.details||body.error||message}catch{}}
  throw new Error(message)
 }
 const r=data as SumUpResult|null
 if(!r?.ok)throw new Error(r?.details||r?.error||'Errore SumUp')
 return r as SumUpResult&{ok:true}
}
export async function launchSumUp(input:{eventId:string;paymentId:string;sessionToken:string;kind:SwitchKind}){
 const r=await sumupSwitch('launch',input);if(r.simulated||r.paid)return r;if(!r.launchUrl)throw new Error('Link SumUp non disponibile');window.location.href=r.launchUrl;return r
}
export async function verifySumUp(input:{eventId:string;paymentId:string;sessionToken:string;kind:SwitchKind}){return sumupSwitch('status',input)}
export async function preparePendingSumUp(input:{eventId:string;orderId:string;sessionToken:string;kind:SwitchKind}){
 const {data,error}=await supabase.rpc('prepare_pending_order_sumup',{target_event_id:input.eventId,target_order_id:input.orderId,target_session_token:input.sessionToken,target_kind:input.kind})
 if(error)throw error
 if(!data)throw new Error('Pagamento pendente non disponibile')
 return String(data)
}
